import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpHandler, HttpEvent, HTTP_INTERCEPTORS, HttpRequest } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class WithCredentialsInterceptor implements HttpInterceptor {
  constructor() {}
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!environment.production && request.url.includes('localhost')) {
      request = request.clone({ withCredentials: true });
    }
    return next.handle(request);
  }
}

export let WithCredentialsInterceptorProvider = {
  provide: HTTP_INTERCEPTORS,
  useClass: WithCredentialsInterceptor,
  multi: true
};
